import Vue from 'vue';

import { firestore } from 'firebase';
import firebase from 'firebase';
import { firestorePlugin } from 'vuefire';

var firebaseConfig = {
  apiKey: 'AIzaSyDTizi5tYFJG6OQOXcK9RQSmejH4XblZqs',
  authDomain: 'codehoney-app.firebaseapp.com',
  databaseURL: 'https://codehoney-app.firebaseio.com',
  projectId: 'codehoney-app',
  storageBucket: 'codehoney-app.appspot.com',
  messagingSenderId: '996273280187',
  appId: '1:996273280187:web:f4c302820c7b2ed804c59e',
  measurementId: 'G-WCJM1H0C8B',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.use(firestorePlugin);
const db = firestore();
const { Timestamp, GeoPoint } = firestore;

export { Timestamp, GeoPoint };
export default db;
